// Upload Flow Types - Simplified flow with creative grouping
import { AdMetadata, FileWithStatus } from './index';

export enum UploadStep {
  FILE_SELECTION = 'file_selection',
  PRODUCTION_SELECTION = 'production_selection', 
  INDIVIDUAL_METADATA = 'individual_metadata',
  TAG = 'tag',
  REVIEW_UPLOAD = 'review_upload'
}

export enum CreativeAssignmentMode {
  NEW = 'new',
  EXISTING = 'existing'
}

export interface CreativeGroup {
  id: string;
  name: string;
  creativeNumber: number;
  fileIds: string[];
  metadata: {
    name_en: string;
    language: string;
    watchers: string[];
    created_by: string;
  };
}

export interface ExistingAssignment {
  creativeNumber: number | null;
  ratio: string;
  isValid: boolean;
  error?: string;
  sourceAdId?: string;
}

export interface TagMetadata {
  licensedSong?: string[];
  licensedSongIds?: string[];
  cast: 'Kids' | 'Couple' | 'Solo actor' | 'No Human actor' | 'Human with Prompt' | 'hand only' | 'Family' | 'unknown';
  heroAge: 'Senior' | 'Adult' | 'Teenage' | 'Kid' | 'unknown';
  heroGender: 'Female' | 'Male' | 'other' | 'unknown';
  pianoType?: 'Piano' | 'Keyboard' | 'Mixed' | 'No instrument' | 'unknown';
  appDevice?: 'phone' | 'tablet' | 'both' | 'no device' | 'unknown';
  meantTo?: string[];
  audience?: string[];
  seasonal?: string[];
  contentShownInApp?: string[];
}

export interface UploadWizardState {
  currentStep: UploadStep;
  files: FileWithStatus[];
  productionId: number | null;
  assignmentMode?: CreativeAssignmentMode; // default: new
  existingAssignments?: Map<string, ExistingAssignment>; // keyed by fileId
  individualMetadata: Map<string, AdMetadata>;
  creativeGroups: Map<string, CreativeGroup>;
  tagMetadata: Map<number, TagMetadata>; // keyed by creative_number
  actorLicenseIds: string[];
  originalActorLicenseIds: string[];
  stepValidation: Record<UploadStep, boolean>;
  isUploading: boolean;
}